import FormattedMessage from 'I18n/components/FormattedMessage';
import { COMMERCE_PAYMENT_TYPE_ID, INVOICE_TYPE_ID, SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { Flex } from 'foundations-components/components/Flex';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Small } from 'foundations-components/transitional/components/Small';
import { useObjectTypeForZeroState } from '../hooks/useObjectTypeForZeroState';
import { CreateCommerceToolButtonForReportWithPaymentsEmbedPointContextProvider as CreateCommerceToolButtonForReport } from './CreateCommerceToolButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getAlertTextForType = type => {
  switch (type) {
    case COMMERCE_PAYMENT_TYPE_ID:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-enablement.zeroState.alerts.payment.text"
      });
    case INVOICE_TYPE_ID:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-enablement.zeroState.alerts.invoice.text"
      });
    case SUBSCRIPTION_TYPE_ID:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-enablement.zeroState.alerts.subscription.text"
      });
    case 'setUpPayments':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-enablement.zeroState.alerts.setUpPayments.text"
      });
    default:
      return null;
  }
};
const ZeroStateAlert = ({
  configReport
}) => {
  const type = useObjectTypeForZeroState(configReport);
  const alertText = getAlertTextForType(type);
  if (!alertText) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    inlineSize: "100%",
    position: "absolute",
    insetBlockEnd: "500",
    insetInlineStart: "0",
    justifyContent: "center",
    paddingInline: "500",
    onClick: e => e.stopPropagation(),
    children: /*#__PURE__*/_jsx(Alert, {
      children: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(Small, {
          children: alertText
        }), /*#__PURE__*/_jsx(CreateCommerceToolButtonForReport, {
          report: configReport,
          location: "zeroStateAlert"
        })]
      })
    })
  });
};
export default ZeroStateAlert;